import clsx from 'clsx'
import { Button, Grid, Icon } from 'gu-ui-kit'
import PropTypes from 'prop-types'
import React from 'react'
import styles from 'modules/Statistics/Pulse/components/CardSettings/CardSettings.module.scss'
import { useTranslation } from 'react-i18next'

export const CardSettings = ({
  className = '',
  isActive = false,
  handleRemove,
}) => {
  const { t } = useTranslation()

  return (
    <Grid
      direction={'column'}
      className={clsx(styles['card-settings'], className)}
      alignItems={'flex-start'}
      fluid={false}
    >
      <Button
        variant={'link'}
        noHover
        // ghost
        size={'s'}
        noLabel
        title={t('pulse::metrics.remove_metric')}
        className={styles['card-settings__close-button']}
        onClick={(e) => {
          e.stopPropagation()
          handleRemove(e)
        }}
        startIcon={
          <Icon
            className={clsx(styles['card-settings__icon'], {
              [styles['card-settings__icon_active']]: isActive,
            })}
            name="close"
            size="m"
          />
        }
      />
    </Grid>
  )
}

CardSettings.defaultProps = {
  className: '',
  id: '',
  isActive: false,
  handleRemove: () => {},
}

CardSettings.propTypes = {
  className: PropTypes.string,
  id: PropTypes.string,
  isActive: PropTypes.bool,
  handleRemove: PropTypes.func,
}
